import moduleTemplate from '@/store/moduleTemplate'
import trackDeviceApi from '@/api/trackDevice'

export default moduleTemplate(trackDeviceApi)
